// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"ScrollbarVertical_scrollbar_3ebRV","bobber":"ScrollbarVertical_bobber_Ydw73"};